import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'orderHistories';
export const orderHistoriesActions = makeActions(
  MODEL_NAME,
  'id',
  'order-histories',
);

export const getAllOrderHistories = orderHistoriesActions.getAll;
export const editOrderHistories = orderHistoriesActions.edit;
export const createOrderHistories = orderHistoriesActions.create;
export const getByIdOrderHistories = orderHistoriesActions.getDataById;
